import { useLogout } from "@/modules/auth/hooks/useLogout"
import { Path } from "@/modules/navigation/routes"
import { useEffect, useRef, useState } from "react"
import { Navigate } from "react-router"

/**
 * Manual logout entry point — navigate to /logout (e.g. paste the URL) to force-close the session.
 * Runs the full logout once, then redirects to login.
 */
export const LogoutPage = () => {
  const logout = useLogout()
  const [done, setDone] = useState(false)
  // logout's identity is unstable (ThemeProvider re-creates setTheme every render). Run it exactly
  // once via a ref so the effect can't re-fire and loop ("Maximum update depth exceeded").
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true
    void logout().finally(() => {
      setDone(true)
    })
  }, [logout])

  if (done) return <Navigate to={Path.Login} replace />

  return null
}
